import styled from 'styled-components';

export const Container = styled.div`
  .modal-get-gift-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    font-size: 1.4rem;
    height: 10.5rem;

    strong {
      color: var(--blue_light);
    }

    .modal-get-gift-details {
      display: flex;
      align-items: center;
      gap: 2rem;
    }

    .modal-get-gift-details img {
      max-width: 10rem;
    }

    .modal-get-gift-details .modal-get-gift-name {
      display: flex;
      flex-direction: column;
      width: 15rem;
      text-overflow: ellipsis;
      overflow-x: hidden;
    }

    .modal-get-gift-details .modal-get-gift-name span {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow-y: hidden;
    }
  }

  @media (max-width: 470px) {
    .modal-get-gift-details {
      flex-direction: column;

      .modal-get-gift-name {
        grid-template-columns: 1rem;
        margin-bottom: 1rem;
      }
    }

    strong {
      text-align: center;
    }
  }
`;
